import { useCustomViewDialogStore } from "csi/middleware/customView/CustomViewDialogStore";
import { SingleSelect } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";

const ImageExportFormat: FunctionComponent = observer(function ImageExportFormat() {
	const { imageFormatStore } = useCustomViewDialogStore();

	const {
		data,
		selectedImageExportFormat,
		setImageExportFormat,
	} = imageFormatStore;

	return (
		<SingleSelect
			disableClearable
			fullWidth
			labelRes="CustomViewImageExportFormat"
			onChange={setImageExportFormat}
			options={data}
			value={selectedImageExportFormat}
		/>
	);
});

export default ImageExportFormat;